import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'SOLICITACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'SOLICITACAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('solicitacaoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/solicitacao`)
		.then(resp => {
			dispatch({
		        type: 'SOLICITACAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/solicitacao`, {
				...registro,
				datahora_confirmacao: DateFormat.getDataHoraAtual(),
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				
				if (registro.entrega && registro.entrega.id_veiculo && registro.entrega.id_motorista) {
					await axios.post(`${consts.API_URL}/entrega`, {
						...registro,
						id_solicitacao: resp.data.id,						
						id_veiculo: registro.entrega.id_veiculo,
						id_motorista: registro.entrega.id_motorista,
						data_agendamento: registro.entrega.data_agendamento,
						quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
						id_unidade_medida: registro.id_unidade_medida,
						id_usuario_inclusao: getState().auth.usuario.id,
						id_usuario_alteracao: getState().auth.usuario.id
					}).then(async resp => {
					}).catch(e => {
						setErroAPI(e);
					});
				}
				
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/solicitacao`, {
				...registro,
				datahora_confirmacao: registro.datahora_confirmacao ? registro.datahora_confirmacao : DateFormat.getDataHoraAtual(),
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {

				if (registro.entrega && registro.entrega.id_veiculo && registro.entrega.id_motorista) {
					if (!registro.entrega.id) {
						await axios.post(`${consts.API_URL}/entrega`, {
							id_solicitacao: registro.id,
							id_veiculo: registro.entrega.id_veiculo,
							id_motorista: registro.entrega.id_motorista,
							data_agendamento: registro.entrega.data_agendamento,
							quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
							id_unidade_medida: registro.id_unidade_medida,
							id_usuario_inclusao: getState().auth.usuario.id,
							id_usuario_alteracao: getState().auth.usuario.id
						}).then(async resp => {
						}).catch(e => {
							setErroAPI(e);
						});
					} else {
						await axios.put(`${consts.API_URL}/entrega`, {
							...registro.entrega,
							id_veiculo: registro.entrega.id_veiculo,
							id_motorista: registro.entrega.id_motorista,
							data_agendamento: registro.entrega.data_agendamento,
							quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
							id_unidade_medida: registro.id_unidade_medida,
							id_usuario_inclusao: getState().auth.usuario.id,
							id_usuario_alteracao: getState().auth.usuario.id
						}).then(async resp => {
						}).catch(e => {
							setErroAPI(e);
						});
					}
				}

				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/solicitacao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/solicitacaoTipo`);
    return {
        type: 'SOLICITACAO_TIPO_SELECT_LISTADO',
        payload: request
    };
}